<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-body w-100 pb-0 pr-3">
        <div class="row">
          <div class="col-lg-2 col-12 mb-1 mb-lg-0">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterList()" />
          </div>
          <div class="col-lg-3 col-12 mb-1 mb-lg-0">
            <ng-select
              class="w-100"
              id="figure"
              [(ngModel)]="filterFigure"
              [closeOnSelect]="true"
              placeholder="{{ 'FIGURE' | translate }}"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [clearable]="true"
              (ngModelChange)="filterList()"
            >
              <ng-option *ngFor="let figure of figuresList" [value]="figure.id">{{ figure.name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-lg-7 col-12">
            <div class="row justify-content-lg-end justify-content-center pl-1">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
                <label class="d-flex align-items-center mb-0"
                  >{{ "SHOW" | translate }}
                  <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <a class="btn btn-outline-primary text-primary" href="dashboard/job-positions/add" *ngIf="_authenticationService.hasCapability('create_job_position')">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>
      </div>

      <!-- desktop-->
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 75 : 270"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="filteredJobPositionList"
        >
          <ngx-datatable-column [name]="'TITLE' | translate" prop="title" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="text-break-line-2" *ngIf="!_authenticationService.hasCapability('view_job_position')">{{ row.title }}</div>
              <a class="text-break-line-2" *ngIf="_authenticationService.hasCapability('view_job_position')" [routerLink]="'/dashboard/job-positions/view/' + row.id">{{ row.title }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'JOB_CATEGORY' | translate" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.category_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CITY' | translate" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.city_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'MODE' | translate" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.site_name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'REQUEST' | translate" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a href="dashboard/detail-request/{{ row.request_id }}" class="text-break-line-2" *ngIf="!!row.request_name">{{ row.request_name ? row.request_name : "-" }}</a>
              <span *ngIf="!row.request_name">-</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" width="70" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <a class="text-secondary mr-1" href="dashboard/job-positions/edit/{{ row.slug }}" *ngIf="_authenticationService.hasCapability('edit_job_position')"><i [data-feather]="'edit-2'" size="19"></i></a>
                <button (click)="delete(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_job_position')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" *ngIf="!_utilService.isDesktop" width="700" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12 text-break-line-2">{{ row.title }}</div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "JOB_CATEGORY" | translate }}: </span>
                  <span>{{ row.category_name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "CITY" | translate }}: </span>
                  <span>{{ row.city_name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "MODE" | translate }}: </span>
                  <span>{{ row.site_name }}</span>
                </div>
                <div class="col-12 text-break-line-1" *ngIf="!!row.request_name">
                  <span class="font-weight-bold">{{ "REQUEST" | translate }}: </span>
                  <a href="dashboard/detail-request/{{ row.request_id }}">{{ row.request_name }}</a>
                </div>
                <div class="col-12 mt-075 text-right">
                  <div class="d-flex justify-content-end">
                    <button class="bg-transparent border-0 pr-1" *ngIf="_authenticationService.hasCapability('view_job_position')">
                      <a href="dashboard/job-positions/view/{{ row.id }}"><i [data-feather]="'eye'" size="19"></i></a>
                    </button>
                    <button class="bg-transparent border-0 pr-1" *ngIf="_authenticationService.hasCapability('edit_job_position')">
                      <a class="text-secondary" href="dashboard/job-positions/edit/{{ row.slug }}"><i [data-feather]="'edit-2'" size="19"></i></a>
                    </button>
                    <button (click)="delete(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_job_position')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>
